export default {
    top: {
        fixedX: null,
        fixedY: 1,
        positionX: 'right',
        positionY: 'top'
    },
    right: {
        fixedX: 1,
        fixedY: null,
        positionX: 'right',
        positionY: 'middle'
    },
    bottom: {
        fixedX: null,
        fixedY: null,
        positionX: 'right',
        positionY: 'bottom'
    },
    left: {
        fixedX: 1,
        fixedY: null,
        positionX: 'left',
        positionY: 'middle'
    },
    unit: {
        fixedX: null,
        fixedY: null,
        positionX: 'right',
        positionY: 'middle'
    }
} 